<template>
    <div class="data-section">
        <ModelSelect
            label="Семейное положение"
            :items="dictionaryByType('marital_status')"
            item-value="id"
            item-text="field_value"
            v-model="martial.foreignMaritalStatusId"
        />

        <ModelString type="number" label="Количество детей" v-model="martial.children" />

        <ModelString label="Девичья/прежняя фамилия" v-model="martial.maidenSurname" />
    </div>
</template>

<script>
import ModelSelect from '../../../UI/models/ModelSelect';
import ModelString from '../../../UI/models/ModelString';
import { mapActions, mapGetters } from 'vuex';

const getters = ['dictionaryByType'];

const actions = ['loadDictionaryItems'];

export default {
    name: 'WideMartialData',
    props: {
        martial: Object,
    },
    data: () => ({
        statuses: [
            {
                id: 1,
                text: 'Холост',
            },
            {
                id: 2,
                text: 'В активном поиске',
            },
            {
                id: 3,
                text: 'В пассивном поиске',
            },
            {
                id: 4,
                text: 'Женат',
            },
            {
                id: 5,
                text: 'Все сложно',
            },
            {
                id: 6,
                text: 'Все очень плохо',
            },
        ],
    }),
    model: {
        prop: 'martial',
        event: 'change',
    },
    components: {
        ModelSelect,
        ModelString,
    },
    methods: {
        ...mapActions(actions),
    },
    computed: {
        ...mapGetters(getters),
    },
    mounted() {
        this.loadDictionaryItems('marital_status');
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
